import { FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Revisione53State } from '../../../../store/revisione53.reducers';
import { bindComuneProvincia } from './norme-comune-provincia.helper';
import { getControl } from '@shared/helpers/form.helper';
import { toBoolean } from '@shared/helpers/utils.helper';
import { updateVerbaleOnStore } from '@core/helpers/create-validator.helper';
import { MySpdElemConsiglioSorveglianzaEntity, MySpmElemComitatoGestioneEntity, MyVerbale } from '../../../../models/interfaces/revisione.interface';
import { cloneDeep } from 'lodash-es';
import { formPaths } from '@shared/constants/form-paths.const';

const controlloCheckOrganoBase = (form: FormGroup, store: Store<Revisione53State>, members: unknown[], ckRevisoreKey: string, ckSocioKey: string): void => {
    let revLegali = 0;
    let soci = 0;

    members.forEach((m) => {
        const member = m as Record<string, unknown>;
        const isRevisoreLegale = toBoolean(member[ckRevisoreKey]) === true || member[ckRevisoreKey] === '1';
        const isSocio = toBoolean(member[ckSocioKey]) === true || member[ckSocioKey] === '1';

        if (isRevisoreLegale) {
            revLegali++;
        }

        if (isSocio) {
            soci++;
        }
    });

    const revLegaliStr = revLegali.toString(10);
    const sociStr = soci.toString(10);

    getControl(form, `${formPaths.ammControllo}.my_ControlloRevLegali`)?.setValue(revLegaliStr, { emitEvent: false });
    getControl(form, `${formPaths.ammControllo}.my_ControlloSoci`)?.setValue(sociStr, { emitEvent: false });

    updateVerbaleOnStore(store, (myVerbale) => {
        const clone: MyVerbale = cloneDeep(myVerbale);
        const ac = clone.my_SezioneI__Rilevazione.my_AmministrazioneControllo;
        ac.my_ControlloRevLegali = revLegaliStr;
        ac.my_ControlloSoci = sociStr;
        return clone;
    });
};

export const controlloCheckConsiglioSorveglianza = (form: FormGroup, store: Store<Revisione53State>, formConsSorv: MySpdElemConsiglioSorveglianzaEntity[] = []): void => {
    controlloCheckOrganoBase(form, store, Array.isArray(formConsSorv) ? formConsSorv : [], 'my_SpdConsSorvCkRevisore', 'my_SpdConsSorvCkSocio');
};

export const controlloCheckComitatoControllo = (form: FormGroup, store: Store<Revisione53State>, formComitGest: MySpmElemComitatoGestioneEntity[] = []): void => {
    controlloCheckOrganoBase(form, store, Array.isArray(formComitGest) ? formComitGest : [], 'my_SpmComitGestCkRevisore', 'my_SpmComitGestCkSocio');
};

export const my_SpdConsSorvComuneProvincieCH = (form: FormGroup, store: Store<Revisione53State>): void => {
    bindComuneProvincia(
        form,
        store,
        `${formPaths.ammControllo}.my_NormeSpaDualistico.my_SpdConsiglioSorveglianza.my_SpdElemConsiglioSorveglianza`,
        { codeKey: 'my_SpdConsSorvComuneCH', idKey: 'my_SpdConsSorvIdComune', nameKey: 'my_SpdConsSorvComune' },
        { codeKey: 'my_SpdConsSorvProvinciaCH', idKey: 'my_SpdConsSorvIdProvincia', nameKey: 'my_SpdConsSorvProvincia' }
    );
};

export const my_SpdConsGestComuneProvinciaCH = (form: FormGroup, store: Store<Revisione53State>): void => {
    bindComuneProvincia(
        form,
        store,
        `${formPaths.ammControllo}.my_NormeSpaDualistico.my_SpdConsiglioGestione.my_SpdElemConsiglioGestione`,
        { codeKey: 'my_SpdConsGestComuneCH', idKey: 'my_SpdConsGestIdComune', nameKey: 'my_SpdConsGestComune' },
        { codeKey: 'my_SpdConsGestProvinciaCH', idKey: 'my_SpdConsGestIdProvincia', nameKey: 'my_SpdConsGestProvincia' }
    );
};

export const my_SpmComitGestComuneCH = (form: FormGroup, store: Store<Revisione53State>): void => {
    bindComuneProvincia(
        form,
        store,
        `${formPaths.ammControllo}.my_NormeSpaMonistico.my_SpmComitatoGestione.my_SpmElemComitatoGestione`,
        { codeKey: 'my_SpmComitGestComuneCH', idKey: 'my_SpmComitGestIdComune', nameKey: 'my_SpmComitGestComune' },
        { codeKey: 'my_SpmComitGestProvinciaCH', idKey: 'my_SpmComitGestIdProvincia', nameKey: 'my_SpmComitGestProvincia' }
    );
};
